(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gr-autumn-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.getElementById('gr-autumn-notice');
    if (!notice || typeof notice.showModal !== 'function') return;
    const expiry = Date.parse('2026-10-07T00:00:00+02:00');
    if (Date.now() >= expiry) return;
    const key = 'gr-autumn-notice-2026';
    notice.addEventListener('close', () => {
      try { sessionStorage.setItem(key, 'dismissed'); } catch {}
    });
    const show = (rememberDismissal = true) => {
      if (rememberDismissal) {
        try { if (sessionStorage.getItem(key) === 'dismissed') return; } catch {}
      }
      if (Date.now() < expiry && !notice.open && !document.querySelector('dialog[open]')) {
        notice.showModal();
      }
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#gr-autumn-notice"]');
      if (!trigger) return;
      event.preventDefault();
      show(false);
    });
    if (notice.dataset.autoOpen === 'true') {
      if (document.readyState === 'complete') show();
      else window.addEventListener('load', () => show(), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gr-festival-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.getElementById('gr-festival-notice');
    if (!notice || typeof notice.showModal !== 'function') return;
    const expiry = Date.parse('2026-11-02T00:00:00+01:00');
    if (Date.now() >= expiry) {
      document.querySelectorAll('a[href*="/blogs/news/swiss-coffee-festival-2026"]').forEach((link) => {
        const announcement = link.closest('.announcement-bar');
        if (announcement) {
          const section = announcement.closest('.shopify-section');
          if (section) section.hidden = true;
        }
      });
      return;
    }
    const key = 'gr-festival-notice-2026';
    notice.querySelector('.gr-festival-notice__cta')?.addEventListener('click', () => {
      try { sessionStorage.setItem(key, 'dismissed'); } catch {}
    });
    notice.addEventListener('close', () => {
      try { sessionStorage.setItem(key, 'dismissed'); } catch {}
    });
    const show = (rememberDismissal = true) => {
      if (rememberDismissal) {
        try { if (sessionStorage.getItem(key) === 'dismissed') return; } catch {}
      }
      if (Date.now() < expiry && !notice.open && !document.querySelector('dialog[open]')) notice.showModal();
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#gr-festival-notice"]');
      if (!trigger) return;
      event.preventDefault();
      show(false);
    });
    if (notice.dataset.autoOpen === 'true') {
      if (document.readyState === 'complete') show();
      else window.addEventListener('load', () => show(), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gr-roast-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-roast-profile')) {
  customElements.define('gr-roast-profile', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-roast-open]');
      if (!dialog || !opener) return;
      opener.addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }, { signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, { signal });
      dialog.addEventListener('close', () => opener.focus(), { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
